"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    GOOGLE_MAP_API_KEY: ()=>GOOGLE_MAP_API_KEY,
    PRICELINE_MAP_ID: ()=>PRICELINE_MAP_ID
});
const PRICELINE_MAP_ID = '9b78a88e3a09bc92';
const GOOGLE_MAP_API_KEY = 'AIzaSyA3oQ_k-qetNGi1rYpeR2zlIoWQqczXnls';
exports.GOOGLE_MAP_API_KEY = __webpack_exports__.GOOGLE_MAP_API_KEY;
exports.PRICELINE_MAP_ID = __webpack_exports__.PRICELINE_MAP_ID;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "GOOGLE_MAP_API_KEY",
    "PRICELINE_MAP_ID"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
